import { CollisionSystem, ModelLoadedEventSystem, PlannerCoreApi, SelectionEventSystem, MeasurementsWidgetSystem, HighlightAddedEntitySystem, UnavailableProductsEventSystem, HistoryEventSystem, InvalidFramePlacementSystem, OutlineSelectedFrameSystem, HistoryApi, ConflictSystem, ConflictOutlineSystem, InteractableFrameSystem, StackingDisabledValidation, StackingHeightRestrictionValidation, AdaptAdjustableSystem, ExpandClothRailSystem, FrameDragAdaptAdjustableClothRailSystem, FrameDragValidation } from '@inter-ikea-storageone/range';
import { OutlineSystem, StandardSelectionSystem, FunctionalMarginSystem, FunctionalMarginValidation, PlacementZoneValidation, RequiredConnectorsSatisfiedValidation, AlignmentConnectionCreationSystem } from '@inter-ikea-core/core';
import { JonaxelEntityApi } from './JonaxelEntityApi';
import { JonaxelProductApi } from './JonaxelProductApi';
import { JonaxelSceneApi } from './JonaxelSceneApi';
import { SimpleOutlineSelectedSystem } from '@inter-ikea-core/core-toolbox';
import { JonaxelCameraApi } from './JonaxelCameraApi';
import RemoveClothRailBoundsOnFrameDragSystem from '@inter-ikea-storageone/range/src/core-api/systems/RemoveClothRailBoundsOnFrameDragSystem';
import ClothrailMinMaxConnectorsSystem from './systems/ClothrailMinMaxConnectorsSystem';
import { AdjustableClothRailValidation } from './validations/AdjustableClothRailValidation';
import RemoveClothRailWhenRemovingFrameSystem from '@inter-ikea-storageone/range/src/core-api/systems/RemoveClothRailWhenRemovingFrameSystem';
import FrameMinMaxConnectorsSystem from './systems/FrameMinMaxConnectorsSystem';
export class JonaxelCoreApi extends PlannerCoreApi {
    bootstrap(config) {
        if (!this.core) {
            throw new Error('Core not initialized yet');
        }
        // Setup core base functionality
        const { selectionService, placementService } = super.initializeBaseCoreFunctionality();
        // Register core systems
        this.registerSystem(new FunctionalMarginSystem());
        this.registerSystem(new StandardSelectionSystem(this.core.services.entityManager, this.core.services.sceneManager));
        // Register core validations
        this.registerValidation(new RequiredConnectorsSatisfiedValidation());
        this.registerValidation(new FunctionalMarginValidation(false, this.core.services.entityManager));
        this.registerValidation(new PlacementZoneValidation());
        // Setup plannner APIs
        this.products = new JonaxelProductApi(this.core.services, placementService, this.reportErrorToSentry);
        this.entities = new JonaxelEntityApi(selectionService, this.core, placementService, this.ipexViewer, this.reportErrorToSentry);
        this.history = new HistoryApi(this);
        // Register planner validations
        this.registerValidation(new StackingHeightRestrictionValidation());
        this.registerValidation(new StackingDisabledValidation(this));
        this.registerValidation(new AdjustableClothRailValidation(this));
        this.registerValidation(new FrameDragValidation(this));
        // Register planner systems
        this.registerSystem(new CollisionSystem(this, []));
        this.registerSystem(new OutlineSystem());
        this.registerSystem(new SimpleOutlineSelectedSystem());
        this.registerSystem(new ModelLoadedEventSystem(this));
        this.registerSystem(new UnavailableProductsEventSystem(this));
        this.registerSystem(new AlignmentConnectionCreationSystem(this.getServices()));
        this.registerSystem(new InvalidFramePlacementSystem(this));
        this.registerSystem(new SelectionEventSystem(this));
        this.registerSystem(new OutlineSelectedFrameSystem(this));
        this.registerSystem(new HistoryEventSystem(this));
        this.registerSystem(new MeasurementsWidgetSystem(this));
        this.registerSystem(new HighlightAddedEntitySystem(this));
        this.registerSystem(new ConflictSystem(this));
        this.registerSystem(new ConflictOutlineSystem(this));
        this.registerSystem(new InteractableFrameSystem(this));
        this.registerSystem(new AdaptAdjustableSystem(this));
        this.registerSystem(new RemoveClothRailBoundsOnFrameDragSystem(this));
        this.registerSystem(new FrameDragAdaptAdjustableClothRailSystem(this));
        this.registerSystem(new ClothrailMinMaxConnectorsSystem(this));
        this.registerSystem(new RemoveClothRailWhenRemovingFrameSystem(this));
        this.registerSystem(new FrameMinMaxConnectorsSystem(this));
        this.registerSystem(new ExpandClothRailSystem(this));
        return this.loadProductCatalogs(config.productCatalogs);
    }
    getMainProductCatalog() {
        return this.catalogs['jonaxel'];
    }
    initSceneApi() {
        this.scene = new JonaxelSceneApi(this.core, this.ipexViewer, this.reportErrorToSentry);
    }
    initCameraApi(canvas) {
        this.camera = new JonaxelCameraApi(this.core.services.sceneManager, this.ipexViewer, this.core.services.entityManager, this, canvas);
    }
    /**
     *
     * @override
     */
    async loadScene(config, setRoom) {
        const frameDragValidation = this.getServices().validations.validations.find(v => v.id === 'FRAME_DRAG_VALIDATION');
        const adjustableClothRailValidation = this.getServices().validations.validations.find(v => v.id === 'ADJUSTABLE_CLOTH_RAIL_VALIDATION');
        frameDragValidation?.disable();
        adjustableClothRailValidation?.disable();
        super.loadScene(config, setRoom);
        frameDragValidation?.enable();
        adjustableClothRailValidation?.enable();
    }
}
//# sourceMappingURL=JonaxelCoreApi.js.map